import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.css']
})
export class FormControlComponent {
  @Input() customLabel: boolean = false;
  @Input() label: string
  @Input() inline: boolean = false;
  @Input() helpText: string;

  constructor() { }
}
